import { TFunction } from 'i18next';
import { DailyTimeslotDto } from '@/app/store/api/restApi';
import { WheelPickerVariantType } from '@/shared/components';

export interface ScheduleDateWithIntervals {
  date: Date;
  intervals: WheelPickerVariantType[];
}

const addAsapForToday = (scheduleDates: ScheduleDateWithIntervals[], t: TFunction<'basket', undefined>) => {
  let asapScheduleDates: ScheduleDateWithIntervals[] = [];
  const todayExists = scheduleDates.find((sd) => new Date(sd.date).toDateString() === new Date().toDateString());

  if (todayExists)
    asapScheduleDates = scheduleDates.map((sd) => {
      if (new Date(sd.date).toDateString() === new Date().toDateString())
        return { ...sd, intervals: [{ value: 'asap', title: t('when.asap') }, ...sd.intervals] };
      return sd;
    });
  else {
    scheduleDates.unshift({ date: new Date(), intervals: [{ value: 'asap', title: t('when.asap') }] });
    asapScheduleDates = scheduleDates;
  }

  return asapScheduleDates;
};

export const generateTimeIntervals = (
  scheduleItems: DailyTimeslotDto[],
  asap: boolean,
  t: TFunction<'basket', undefined>,
) => {
  const result: ScheduleDateWithIntervals[] = [];

  // Группируем элементы по датам
  const groupedByDate = scheduleItems.reduce(
    (acc, item) => {
      const dateKey = item.date;
      if (!acc[dateKey]) acc[dateKey] = [];

      acc[dateKey].push(item);
      return acc;
    },
    {} as Record<string, DailyTimeslotDto[]>,
  );

  // Обрабатываем каждую дату
  Object.entries(groupedByDate).forEach(([, items]) => {
    const allIntervals: WheelPickerVariantType[] = [];

    items
      .map((item) => {
        // Нормализуем время окончания
        if (item.end.hours === 0 && item.end.minutes === 0) item.end.hours = 24;
        return item;
      })
      .forEach((item) => {
        // Пропускаем нерабочие дни или некорректные интервалы
        if (
          item.start.hours > item.end.hours ||
          (item.start.hours === item.end.hours && item.start.minutes >= item.end.minutes)
        )
          return;

        // Создаем временные интервалы с шагом 30 минут для текущего item
        let currentHours = item.start.hours;
        let currentMinutes = item.start.minutes;

        while (true) {
          // Форматируем текущее время
          const currentTime = `${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}`;

          // Вычисляем время окончания интервала (+ 30 минут)
          let endHours = currentHours;
          let endMinutes = currentMinutes + 30;

          // Корректируем переполнение минут
          if (endMinutes >= 60) {
            endHours++;
            endMinutes -= 60;
          }

          // Проверяем, не выходим ли за рамки рабочего времени
          if (endHours > item.end.hours || (endHours === item.end.hours && endMinutes > item.end.minutes)) break;

          // Форматируем время окончания интервала
          const endTime = `${endHours === 24 ? '00' : endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;

          // Создаем интервал
          allIntervals.push({ value: currentTime, title: `${currentTime}-${endTime}` });

          // Переходим к следующему интервалу
          currentHours = endHours;
          currentMinutes = endMinutes;
        }
      });

    // Сортируем интервалы по времени и удаляем дубликаты
    const sortedIntervals = allIntervals
      .sort((a, b) => a.value.localeCompare(b.value))
      .filter((interval, index, array) => index === 0 || array[index - 1].value !== interval.value);

    // Добавляем результат для текущей даты, если есть интервалы
    if (sortedIntervals.length > 0) result.push({ intervals: sortedIntervals, date: new Date(items[0].date) });
  });

  return asap ? addAsapForToday(result, t) : result;
};
